export const EnforceOfficeDashboardV2 = 'ARF-881-enforce-office-dashboard-v2';
export const EnforcePaymentHistoryTable = 'ARF-949-enforce-update-payment-history-table';
export const ShiftRequestRedesign =
  'TEMP-15776-shift-request-re-design-the-shift-request-flow-dental-portal';
export const TnCOffices = 'TEMP-15427-tnc-offices';
export const ShowAchAuthorizationPopup = 'show-ach-authorization-popup';
export const EnablePermSessionRecording = 'ARF-1725-enable-perm-session-recording-dental-portal';
export const EnableSignUpSessionRecording =
  'TEMP-16399-enable-signup-session-recording-dental-portal';
export const EnforcePostAJobFunnelImprovements = 'ARF-1899-post-a-job-funnel-improvements';
export const EnableDailyPayOption = 'ARF-1866-add-daily-pay-option';
export const DashboardPermNewBadge = 'ARF-1799-dashboard-perm-new-badge';
export const ProfessionalHubRedesign = 'TEMP-15781-Dental-New-to-You-Redesign';
export const PostJobLandingPage = 'ARF-1833-post-job-landing-page';
export const EnablePermanentJobM2M = 'ARF-1552-enable-perm-m2m-dental-portal';
export const CredentialingV2 = 'TEMP-13770-credentialing-v2';
